<script>
import { VFileInput } from 'vuetify/lib';
export default VFileInput.extend({
  props: {
    dense: {
      default: true,
      type: [Boolean, String],
    },
    outlined: {
      default: true,
      type: [Boolean, String],
    },
  },
});
</script>
